import React from 'react';
import StudentNames from './StudentNames';

const CertificateNameQuery = () => {
    return (
        <div className='container mx-auto mt-16 mb-20 px-5 min-h-screen'>            

        <StudentNames></StudentNames>           
            
        </div>
    );
};

export default CertificateNameQuery;